import React from "react";
import search from "../../src/images/search.svg";
import { handleKeyDown } from "../utils/common/inputValidation";

const SearchInput = ({ id, label, placeholder, ...rest }) => {
  return (
    <>
      <div className="relative w-full max-w-96">
        <input
          type="text"
          id={id}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className="peer border border-gray_100 rounded-[10px] py-[6px] px-4 w-full bg-white_50 placeholder-gray_600 placeholder:font-light focus:placeholder-transparent focus-visible:outline-primary_orange"
          {...rest}
        />
        <label
          htmlFor={id}
          className="absolute top-[7px] left-3 bg-white px-1 text-lg font-normal text-primary_orange transition-all duration-300 transform -translate-y-1/2 scale-75 origin-left opacity-0 peer-focus:scale-75 peer-focus:-translate-y-5 peer-focus:opacity-100"
        >
          {label}
        </label>

        <div class="absolute top-2.5 right-1  flex justify-center items-center w-12">
          <img src={search} alt="search-icon" />
        </div>
      </div>
    </>
  );
};

export default SearchInput;
